var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1064_6497)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.14286C6.85123 1.14286 5.74952 1.5992 4.93722 2.4115C4.12492 3.2238 3.66857 4.32552 3.66857 5.47428C3.66857 8.25635 3.16406 9.99937 2.53181 11.0681C2.45502 11.1979 2.37626 11.3179 2.2962 11.4286H13.7058C13.6268 11.3194 13.5489 11.2011 13.473 11.0732C12.8389 10.0057 12.3314 8.26237 12.3314 5.47428C12.3314 4.32552 11.8751 3.2238 11.0628 2.4115C10.2505 1.5992 9.14877 1.14286 8 1.14286ZM8 0C6.54813 0 5.15572 0.576753 4.1291 1.60338C3.10247 2.63001 2.52571 4.02241 2.52571 5.47428C2.52571 8.13222 2.04165 9.65206 1.54819 10.4862C1.30221 10.902 1.05567 11.1449 0.866203 11.2798C0.699716 11.3982 0.594315 11.4225 0.573091 11.4274C0.568473 11.4284 0.56784 11.4286 0.571429 11.4286C0.255837 11.4286 0 11.6844 0 12C0 12.3156 0.255837 12.5714 0.571429 12.5714H15.4286C15.7442 12.5714 16 12.3156 16 12C16 11.6844 15.7442 11.4286 15.4286 11.4286C15.4331 11.4286 15.4325 11.4284 15.4271 11.4271C15.405 11.4218 15.3013 11.3968 15.138 11.2809C14.9489 11.1467 14.7021 10.9046 14.4556 10.4896C13.9611 9.65711 13.4743 8.13762 13.4743 5.47428C13.4743 4.02241 12.8975 2.63001 11.8709 1.60338C10.8443 0.576753 9.45187 0 8 0Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14196 13.5386C6.44737 13.4591 6.75941 13.6422 6.83892 13.9476C6.90584 14.2047 7.05616 14.4323 7.26631 14.5947C7.47647 14.7572 7.73459 14.8453 8.00021 14.8453C8.26583 14.8453 8.52395 14.7572 8.7341 14.5947C8.94426 14.4323 9.09458 14.2047 9.1615 13.9476C9.24101 13.6422 9.55305 13.4591 9.85846 13.5386C10.1639 13.6181 10.347 13.9301 10.2675 14.2356C10.1368 14.7374 9.84335 15.1818 9.43305 15.4989C9.02275 15.8161 8.51881 15.9881 8.00021 15.9881C7.48161 15.9881 6.97767 15.8161 6.56737 15.4989C6.15706 15.1818 5.86358 14.7374 5.73293 14.2356C5.65342 13.9301 5.83654 13.6181 6.14196 13.5386Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_6497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.caa94651e76394964e3e06eb087dc063.svg";
export { ForwardRef as ReactComponent };